import Translator from "/global/external/gettext-translator/src/translator.min.js?v=1743070403";
const translator = new Translator();
let translationsFetched = false;
const getTranslations = async () => {
  if (!translationsFetched) {
    translationsFetched = true;
    const formData = new FormData();
    const urlParts = document.location.pathname.split('/');
    for (const urlPart of urlParts) {
      if (urlPart === "adminSecure" || urlPart === "AssetManager") {
        formData.append('language', 'languageEditBackend');
      }
    }
    const fetchLangData = await fetch('/global/ajaxHandlerGlobal.php?handler=getLanguageThemePlugins', {
      method: "POST",
      body: formData
    });
    const data = await fetchLangData.json();
    translator.domainName = data.domainName;
    translator.tinymceLangCode = data.tinymceLangCode;
    translator.tinymceLangFile = data.tinymceLangFile;
    translator.langCodeFull = data.langCodeFull;
    translator.langCode = data.langCode;
    translator.language = data.language;
    translator.languageEditBackend = data.languageEditBackend;
    translator.companyValidLanguages = data.companyValidLanguages;
    translator.activeTheme = data.activeTheme;
    translator.activePlugins = data.activePlugins;
    translator.cookieBoxAcceptedCookies = data.cookieBoxAcceptedCookies;
    translator.country = data.country;
    translator.department = data.department;
    translator.companyDefaultSettings = data.companyDefaultSettings;
    translator.defaultCurrency = data.defaultCurrency;
    translator.companyValidCurrencies = data.companyValidCurrencies;
    translator.currency = data.currency;
    translator.themeSettings = data.themeSettings;
    translator.userLogin = data.userLogin;
    translator.pwaUrl = data.pwaUrl;
    for (const translation in data.translations) {
      if (data.translations.hasOwnProperty(translation)) {
        translator.loadTranslations(data.translations[translation]);
      }
    }
  }
  return translator;
};
const t = getTranslations();
export { t };